export type { ProductDetailProps } from './product-detail';
export * from './product-detail.routes';

export { default as ProductDetail, default } from './product-detail';
